/**
 * Reads QCS supervision handoff id from the current URL search, or from
 * PrivateRoute redirect state (`state.from.search`) if search was not preserved.
 * Expects `?type=qcs&id=<handoffId>`.
 */
export function getQcsHandoffId(location) {
  const search =
    (location && location.search) ||
    (location && location.state && location.state.from && location.state.from.search) ||
    ''
  if (!search) {
    return null
  }
  const params = new URLSearchParams(search)
  if (params.get('type') !== 'qcs') {
    return null
  }
  const id = params.get('id')
  if (!id || !String(id).trim()) {
    return null
  }
  return String(id).trim()
}
